export default __webpack_public_path__ + "static/media/footer.33a38ed5.png";